import { createSelector } from "@reduxjs/toolkit";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

/**
 * The previewed variation's mods that the merchant has hidden.
 *
 * The intersection is the whole point: `hiddenModIds` is never pruned, so it
 * accumulates ids of deleted mods and of mods in other variations. Deriving
 * hidden-ness here scopes every consumer — the preview, the row controls, the
 * header label, the tracked count — to the variation on screen, and makes a
 * stale id impossible to observe.
 *
 * The complement of `getVisibleVariationMods`.
 */
export const getHiddenVariationMods = createSelector(
  getVariationMods,
  experienceBuilderSlice.selectors.getHiddenModIds,
  (variationMods, hiddenModIds) =>
    variationMods.filter((mod) => hiddenModIds[mod.id])
);
